/*
          第3方数据对接

	h5开启以下代理跨域
	腾讯分钟走势图，5日走势图
	http://127.0.0.1:8715 => http://web.ifzq.gtimg.cn

	新浪分钟K线数据
	http://127.0.0.1:8712=> http://quotes.sina.cn

	腾讯日K 支持跨域
	http://proxy.finance.qq.com/ifzqgtimg/appstock/app/newfqkline/get?_var=kline_dayqfq&param=sh600000,day,,,320,qfq&r=0.23908471470885573
*/
//import realm from 'common/realmName.js';

import axios from 'axios'
import { BASEURL } from '@/utils/realmName'
function HQData()  { }

HQData.RecvDataCallback=null;	//收到数据回调  function(data)

HQData.NetworkFilter=function(data, callback,api_type = 0)
{
   
    switch(data.Name)
    {
        case 'KLineChartContainer::ReqeustHistoryMinuteData':           //分钟全量数据下载
			if (data.Request.Data.symbol.indexOf('.bj')>0)
			{
				HQData.RequestHistoryMinuteDataDongFeng(data, callback);
			}else{
				 HQData.RequestHistoryMinuteData(data, callback);
			}
           
            break;
        case 'KLineChartContainer::RequestMinuteRealtimeData':          //分钟增量数据更新
            HQData.RequestMinuteRealtimeData(data,callback);
            break;

        case 'KLineChartContainer::RequestFlowCapitalData':             //流通股本
            HQData.RequestFlowCapitalData(data,callback);
            break;


        case 'KLineChartContainer::RequestHistoryData':                 //日线全量数据下载
            HQData.RequestHistoryData(data,callback);
            break;

        case 'KLineChartContainer::RequestRealtimeData':                //日线实时数据更新
            HQData.RequestRealtimeData(data,callback);
            break;

        case "MinuteChartContainer::RequestMinuteData":                 //单日分时
            HQData.RequestMinuteData(data,callback);
            break;

        case "MinuteChartContainer::RequestHistoryMinuteData":          //多日分时
            HQData.RequestMinuteDaysData(data,callback);
            break;
    }
}

//股票代码转换成新浪代码
HQData.ConverToSinaSymbol=function(symbol)
{
    var internalSymbol;
    if (symbol.indexOf('.sh')>0)
    {
        internalSymbol=symbol.replace('.sh',"");
        internalSymbol="sh"+internalSymbol;
    }
    else if (symbol.indexOf('.sz')>0)
    {
        internalSymbol=symbol.replace('.sz',"");
        internalSymbol="sz"+internalSymbol;
    }else if (symbol.indexOf('.bj')>0)
    {
        internalSymbol=symbol.replace('.bj',"");
        internalSymbol="bj"+internalSymbol;
    }

    return internalSymbol;
}

//股票代码转腾讯代码
HQData.ConverToQQSymbol=function(symbol)
{
    symbol = String(Array.isArray(symbol) ? symbol[0] : symbol || '');
    if (/^(sh|sz|bj)\d{6}$/i.test(symbol)) return symbol.toLowerCase();
    if (/^\d{6}\.(sh|sz|bj)$/i.test(symbol)) return symbol.slice(-2).toLowerCase() + symbol.slice(0, 6);
    if (/^hk/i.test(symbol)) return 'hk' + symbol.slice(2);
    if (/\.hk$/i.test(symbol)) return 'hk' + symbol.slice(0, -3);
    var internalSymbol;
    if (symbol.indexOf('.sh')>0)
    {
        internalSymbol=symbol.replace('.sh',"");
        internalSymbol="sh"+internalSymbol;
    }
    else if (symbol.indexOf('.sz')>0)
    {
        internalSymbol=symbol.replace('.sz',"");
        internalSymbol="sz"+internalSymbol;
    }else if (symbol.indexOf('.bj')>0)
    {
        internalSymbol=symbol.replace('.bj',"");
        internalSymbol="bj"+internalSymbol;
    }

    return internalSymbol;
}

//新浪分钟K线数据
HQData.GetKMinuteApiUrl=function(symbol, period, count)
{
    var internalSymbol=HQData.ConverToSinaSymbol(symbol);

    var Period_List=new Map(
        [
            [4,1],
            [5,5],
            [6,15],
            [7,30],
            [8,60]
        ]
    );

    var scale=Period_List.get(period);

    //http://quotes.sina.cn/cn/api/jsonp_v2.php/=/CN_MarketDataService.getKLineData?symbol=sh600000&scale=1&datalen=5000



    //var url=`https://quotes.sina.cn/cn/api/jsonp_v2.php/var __kminute__=/CN_MarketDataService.getKLineData?symbol=${internalSymbol}&scale=${scale}&datalen=${count}`;


    // #ifdef H5
    //var url=`/quotes_sina_cn/cn/api/jsonp_v2.php/var __kminute__=/CN_MarketDataService.getKLineData?symbol=${internalSymbol}&scale=${scale}&datalen=${count}`;
    // #endif
	let realmName = BASEURL();
    var url= realmName + `/vexe/v1/stock/sinaRequestMinuteRealtimeData?code=${internalSymbol}&period=${scale}&count=${count}`;

    return { Url:url, Symbol:symbol, InternalSymbol:internalSymbol, Period:period };
}

//腾讯分钟走势图，5日走势图
HQData.GetMinuteApiUrl=function(symbol, dayCount)
{
    //https://web.ifzq.gtimg.cn/appstock/app/minute/query?code=sh600519
    //https://web.ifzq.gtimg.cn/appstock/app/day/query?code=sh600519

    var internalSymbol=HQData.ConverToQQSymbol(symbol);

    if (dayCount==1)
    {
        var url=`https://web.ifzq.gtimg.cn/appstock/app/minute/query?_var=min_data_${internalSymbol}&code=${internalSymbol}`;

    }
    else
    {

        var url=`https://web.ifzq.gtimg.cn/appstock/app/day/query?_var=fdays_data_${internalSymbol}&code=${internalSymbol}`;

    }

    return { Url:url, Symbol:symbol, InternalSymbol:internalSymbol, DayCount:dayCount };
}


//腾讯日K 支持跨域
HQData.GetKDayApiUrl=function(symbol,period,right,count)
{
    // https://proxy.finance.qq.com/ifzqgtimg/appstock/app/newfqkline/get?_var=kline_dayqfq&param=sh600000,day,,,320,qfq&r=0.23908471470885573
    // https://proxy.finance.qq.com/ifzqgtimg/appstock/app/newfqkline/get?_var=kline_weekhfq&param=sh600000,week,,,320,hfq&r=0.9245064943280656
    // https://proxy.finance.qq.com/ifzqgtimg/appstock/app/newkline/newkline?_var=kline_week&param=sh600000,week,,,320,&r=0.5369798987226688
    var internalSymbol=HQData.ConverToQQSymbol(symbol);

    var Period_List=new Map(
        [
            [0,"day"],
            [1,"week"],
            [2,"month"]
        ]
    );

    var periodName=Period_List.get(period);
    if (right==0)
    {
        var fq="";
        var url=`https://proxy.finance.qq.com/ifzqgtimg/appstock/app/newkline/newkline?_var=kline_data&param=${internalSymbol},${periodName},,,${count},`;
    }
    else
    {
        var fq="qfq";
        if (right==2) fq="hfq";

        var url=`https://proxy.finance.qq.com/ifzqgtimg/appstock/app/newfqkline/get?_var=kline_data&param=${internalSymbol},${periodName},,,${count},${fq}`;
    }

    return { Url:url, Symbol:symbol, InternalSymbol:internalSymbol, Period:period, PeriodName:periodName, FuQuan:fq };
}

//分钟K线
HQData.RequestHistoryMinuteData=function(data, callback)
{
    data.PreventDefault=true;
    var symbol=data.Request.Data.symbol; //请求的股票代码
    var period=data.Self.Period;         //周期ID
    var count=1900;
   

    var obj=HQData.GetKMinuteApiUrl2(symbol,period,count);
    
    axios({
        method:'GET',
        url: obj.Url
      }).then(recvData=>{
        if(recvData){
            //eval(recvData.data);
            var jsonStr = recvData.data.split('=');          // 截取 = 后部分
            var kday = JSON.parse(jsonStr[1]);   
            HQData.RecvHistoryMinuteData2(kday, data, callback, obj);
            //HQData.RecvMinuteRealtimeData(kday, data, callback, obj);
        }
      })
   
}

HQData.RecvHistoryMinuteData=function(recvData, data, callback, obj)
{
    //{"day":"2021-03-03 14:15:00","open":"22.860","high":"22.900","low":"22.820","close":"22.830","volume":"2337300","ma_price5":22.796,"ma_volume5":1612649},
    var hqChartData={code:0, data:[]};
    hqChartData.symbol=obj.Symbol;
    hqChartData.name=obj.Symbol;

    var stockInfo={ Symbol:obj.Symbol, Period:data.Self.Period, Right:data.Self.Right };
    var yClose=null;
    var latestData=null;	//最新数据
    for(var i in recvData)
    {
        //if (i==recvData.length-1) break;  //测试自动更新
        var item=recvData[i];
        var day = new Date(item.day);
        var date=day.getFullYear()*10000+(day.getMonth()+1)*100+day.getDate();
        var time=day.getHours()*100+day.getMinutes();

        var newItem=[ date,yClose, parseFloat(item.open), parseFloat(item.high), parseFloat(item.low), parseFloat(item.close), parseFloat(item.volume), null, time];

        hqChartData.data.push(newItem);

        latestData={ Date:item.day, Open:item.open, High:item.high, Low: item.low, Close:item.close, Vol:item.volume, YClose:yClose };

        yClose=parseFloat(item.close);
    }
	
    if (data.Self.IsDestroy==false)
    {
        callback(hqChartData);
        if (HQData.RecvDataCallback)
        {
            HQData.RecvDataCallback( { Data:latestData, Stock:stockInfo, Explain:"分钟K线历史数据",Type: 5});
        }
    }
}

//分钟K线更新
HQData.RequestMinuteRealtimeData=function(data,callback)
{
    data.PreventDefault=true;
    var symbol=data.Request.Data.symbol[0]; //请求的股票代码
    var period=data.Self.Period;         //周期ID
    var count=5;    //取最新5条


    var obj=HQData.GetKMinuteApiUrl2(symbol,period,count);
    axios({
        method:'GET',
        url: obj.Url
      }).then(recvData=>{
        if(recvData){
            var jsonStr = recvData.data.split('=');          // 截取 = 后部分
            var kday = JSON.parse(jsonStr[1]);   
            //eval(recvData.data);
            HQData.RecvMinuteRealtimeData(kday, data, callback, obj);
        }
      })
   
    
}

HQData.RecvMinuteRealtimeData=function(recvData, data, callback, obj)
{
    var hqChartData={code:0, data:[], ver:2.0}; //更新数据使用2.0版本格式
    hqChartData.symbol=obj.Symbol;
    hqChartData.name=obj.Symbol;
    var stockInfo={ Symbol:obj.Symbol, Period:data.Self.Period, Right:data.Self.Right };
    var yClose=null;
    var latestData=null;	//最新数据
    for(var i in recvData)
    {
        var item=recvData[i];
        var day = new Date(item.day);
        var date=day.getFullYear()*10000+(day.getMonth()+1)*100+day.getDate();
        var time=day.getHours()*100+day.getMinutes();
        var newItem=[ date,yClose, parseFloat(item.open), parseFloat(item.high), parseFloat(item.low), parseFloat(item.close), parseFloat(item.volume), null, time];

        hqChartData.data.push(newItem);

        latestData={ Date:item.day, Open:item.open, High:item.high, Low: item.low, Close:item.close, Vol:item.volume, YClose:yClose };

        yClose=parseFloat(item.close);
    }
   
    if (data.Self.IsDestroy==false)
    {
        callback(hqChartData);

        if (HQData.RecvDataCallback)
        {
            HQData.RecvDataCallback( { Data:latestData, Stock:stockInfo, Explain:"分钟K线增量数据", Type: 6 });
        }
    }
}

//流通股本
HQData.RequestFlowCapitalData=function(data,callback)
{
    data.PreventDefault=true;
    var hqChartData={code:0, stock:[]}; //如果没有数据就填空
    if (data.Self.IsDestroy==false)
    {
        callback(hqChartData);
    }
}

//走势图
HQData.RequestMinuteData=function(data, callback)
{
    data.PreventDefault=true;
    var symbol=data.Request.Data.symbol; //请求的股票代码
    //console.log(`[HQData::RequestMinuteData] Symbol=${symbol}`);
    var obj=HQData.GetMinuteApiUrl(symbol,1);
    axios({
        method:'GET',
        url: obj.Url
      }).then(recvData=>{
        if(recvData){
            var jsonStr = recvData.data.split('=');          // 截取 = 后部分
            var kday = JSON.parse(jsonStr[1]);  
            // eval(recvData.data);
			// 	//console.log(eval("min_data_${obj.InternalSymbol}"))
            // eval(`var __minute__=min_data_${obj.InternalSymbol}`);
            HQData.RecvMinuteData(kday, data, callback, obj);
        }
      })
    
}

HQData.RecvMinuteData=function(recvData, data, callback, obj)
{
    var stockData=recvData.data[obj.InternalSymbol];
    var qt=stockData.qt;
    var mintue=stockData.data;

    var dayData=qt[obj.InternalSymbol];
    var yClose=parseFloat(dayData[4]);  //昨收盘
    var date=parseInt(mintue.date);

    var stockInfo={ Symbol:obj.Symbol };

    var aryMinute=[];
    var perVol=0;
    var totalAmount=0;
    var latestData;
    for(var i in mintue.data)
    {
        var item=mintue.data[i];
        var aryData=item.split(" ");
        var price=parseFloat(aryData[1]);
        var vol=HQData.KLineVolume(obj.Symbol, aryData[2]);
        var stockItem=
            {
                time:parseInt(aryData[0]),
                price:price,
                open:price,
                high:price,
                low:price,
                amount:null,
                vol:vol-perVol,
                //avprice:item.avg_price,
            }

        totalAmount+=(stockItem.vol*stockItem.price);
        stockItem.avprice=vol > 0 ? totalAmount/vol : price;  //无成交量时避免 NaN 均价
        perVol=vol;
        aryMinute.push(stockItem);

        latestData={Price:stockItem.price, Vol:stockItem.vol, Date: `${mintue.date} ${aryData[0]}`, AvPrice:stockItem.avprice, YClose:yClose };
    }

    var hqchartData={stock:[{ name:obj.Symbol, symbol:obj.Symbol,date:date,yclose:yClose, minute:aryMinute }], code:0 };
    
    if (data.Self.IsDestroy==false)
    {
        callback(hqchartData);
        if (HQData.RecvDataCallback)
        {
            HQData.RecvDataCallback( { Data:latestData, Stock:stockInfo, Explain:"当日走势图数据", Type: 1 });
        }
    }
}

//5日走势图
HQData.RequestMinuteDaysData=function(data,callback)
{
    data.PreventDefault=true;
    var symbol=data.Request.Data.symbol; //请求的股票代码
    //console.log(`[HQData.RequestMinuteDaysData] Symbol=${symbol}`);
    var obj=HQData.GetMinuteApiUrl(symbol,5);
    axios({
        method:'GET',
        url: obj.Url
      }).then(recvData=>{
        if(recvData){
            var jsonStr = recvData.data.split('=');          // 截取 = 后部分
            var kday = JSON.parse(jsonStr[1]);  
            HQData.RecvMinuteDaysData(kday, data, callback, obj);
        }
      })
   
}

HQData.RecvMinuteDaysData=function(recvData, data, callback, obj)
{
    var stockData=recvData.data[obj.InternalSymbol];
    var qt=stockData.qt;
    var mintue=stockData.data;
    var stockInfo={ Symbol:obj.Symbol };
    var latestData;
    var dayData=qt[obj.InternalSymbol];
    var aryDayData=[];
    for(var i in stockData.data)
    {
        var dayMinute=stockData.data[i];
        var date=parseInt(dayMinute.date);
        var itemDay={ minute:[], date:date, yclose: parseFloat(dayMinute.prec) };
        var totalAmount=0, perVol=0;
        for(var j in dayMinute.data)
        {
            var item=dayMinute.data[j];
            var aryData=item.split(" ");

            var price=parseFloat(aryData[1]);
            var vol=HQData.KLineVolume(obj.Symbol, aryData[2]);

            var stockItem=[parseInt(aryData[0]), price,price,price,price,vol-perVol,null];

            totalAmount+=(stockItem[5]*price);
            stockItem[7]=vol > 0 ? totalAmount/vol : price;
            perVol=vol;
            itemDay.minute.push(stockItem);

            if (i==0)
                latestData={Date:`${dayMinute.date} ${aryData[0]}`,  Price:stockItem[1], Vol:stockItem[5], AvPrice:stockItem[7], YClose:dayMinute.prec };
        }

        aryDayData.push(itemDay);

    }

    var hqchartData={ symbol:obj.Symbol, name:obj.Symbol, data:aryDayData, code:0 };
    
    if (data.Self.IsDestroy==false)
    {
        callback(hqchartData);
        if (HQData.RecvDataCallback)
        {
            HQData.RecvDataCallback( { Data:latestData, Stock:stockInfo, Explain:"多日走势图数据",Type: 2 });
        }
    }

}

HQData.CreateSHSZData=function(minuteStringData)
{
    const TIME_SPLIT =
        [
            { Start: 930, End: 1130 },
            { Start: 1300, End: 1500 }
        ];

    return minuteStringData.CreateTimeData(TIME_SPLIT);
}

HQData.GetSHSZData=function(upperSymbol,width)
{
    const SHZE_MINUTE_X_COORDINATE =
        {
            Full:   //完整模式
                [
                    [0, 0, "rgb(200,200,200)", "09:30"],
                    [31, 0, "RGB(200,200,200)", "10:00"],
                    [61, 0, "RGB(200,200,200)", "10:30"],
                    [91, 0, "RGB(200,200,200)", "11:00"],
                    [120, 1, "RGB(200,200,200)", "13:00"],
                    [150, 0, "RGB(200,200,200)", "13:30"],
                    [180, 0, "RGB(200,200,200)", "14:00"],
                    [210, 0, "RGB(200,200,200)", "14:30"],
                    [240, 1, "RGB(200,200,200)", "15:00"], // 15:00
                ],
            Simple: //简洁模式
                [
                    [0, 0, "rgb(200,200,200)", "09:30"],
                    [61, 0, "RGB(200,200,200)", "10:30"],
                    [120, 1, "RGB(200,200,200)", "13:00"],
                    [180, 0, "RGB(200,200,200)", "14:00"],
                    [240, 1, "RGB(200,200,200)", "15:00"]
                ],
            Min:   //最小模式
                [
                    [0, 0, "rgb(200,200,200)", "09:30"],
                    [120, 1, "RGB(200,200,200)", "13:00"],
                    [240, 1, "RGB(200,200,200)", "15:00"]
                ],

            Count: 242,         //!! 一共的分钟数据个数，不要填错了
            MiddleCount: 121,   // Count/2 就可以。

            GetData: function (width)
            {
                if (width < 200) return this.Min;
                else if (width < 400) return this.Simple;

                return this.Full;
            }
        };

    return SHZE_MINUTE_X_COORDINATE;
}

HQData.RequestHistoryData=function(data,callback)
{
    data.PreventDefault=true;
    var symbol=data.Request.Data.symbol; //请求的股票代码
    var period=data.Self.Period;         //周期ID
    var right=data.Self.Right;
    var count=320;
    //console.log(`[HQData::RequestHistoryData] Symbol=${symbol}, period=${period}, right=${right}`);

    var obj=HQData.GetKDayApiUrl(symbol,period,right,count);
    axios({
        method:'GET',
        url: obj.Url
      }).then(recvData=>{
        if(recvData){
            var jsonStr = recvData.data.split('=');          // 截取 = 后部分
            var kday = JSON.parse(jsonStr[1]);   
            // var code="var "+recvData.data;
            // eval(code);
            // eval("var __kday__=kline_data;")
            HQData.RecvHistoryData(kday, data, callback, obj);
        }
      })

}

// All HQChart periods receive shares: Tencent CN minute/K-line feeds use lots;
// HK feeds use shares. HQChart performs the final CN shares-to-lots display step.
HQData.KLineVolume=function(symbol, value)
{
    return Number(value) * (/^(sh|sz|bj)\d{6}$|^\d{6}\.(sh|sz|bj)$/i.test(symbol) ? 100 : 1);
}

HQData.RecvHistoryData=function(recvData, data, callback, obj)
{
    if (!recvData) return;

    var stockData=recvData.data[obj.InternalSymbol];
    var kLineName=`${obj.FuQuan}${obj.PeriodName}`;
    var jsKline=stockData[kLineName];
	if(jsKline == null || jsKline == undefined){
		var kLineName=`${obj.PeriodName}`;
		var jsKline=stockData[kLineName];
	}
    var hqChartData={code:0, data:[]};
    hqChartData.symbol=obj.Symbol;
    hqChartData.name=obj.Symbol;

    var stockInfo={ Symbol:obj.Symbol, Period:data.Self.Period, Right:data.Self.Right };

    var yClose=parseFloat(stockData.prec);
    var latestData;
    for(var i in jsKline)
    {
        var item=jsKline[i];
        var aryDate = item[0].split('-')
        var date=parseInt(aryDate[0])*10000+parseInt(aryDate[1])*100+parseInt(aryDate[2]);
        var open=parseFloat(item[1]);
        var close=parseFloat(item[2]);
        var high=parseFloat(item[3]);
        var low=parseFloat(item[4]);
        var vol=HQData.KLineVolume(obj.Symbol, item[5]);

        var newItem=[ date,yClose, open, high, low, close, vol, null];

        hqChartData.data.push(newItem);

        latestData={ Date:item[0], Open:item[1], High:item[3], Low: item[4], Close:item[2], Vol:vol, YClose:yClose };

        yClose=close;
    }
    
    if (data.Self.IsDestroy==false)
    {
        callback(hqChartData);
        if (HQData.RecvDataCallback)
        {
            HQData.RecvDataCallback( { Data:latestData, Stock:stockInfo, Explain:"日K线历史数据",Type: 3 });
        }
    }
}

HQData.RequestRealtimeData=function(data,callback)
{
    data.PreventDefault=true;
    var symbol=data.Request.Data.symbol; //请求的股票代码
    var period=data.Self.Period;         //周期ID
    var right=data.Self.Right;
    var count=3;
    //console.log(`[HQData::RequestRealtimeData] Symbol=${symbol}, period=${period}, right=${period}`);

    var obj=HQData.GetKDayApiUrl(symbol,period,right,count);
    axios({
        method:'GET',
        url: obj.Url
      }).then(recvData=>{
        if(recvData){
            // eval("var "+recvData.data);
            // eval("var __kday__=kline_data;")
            var jsonStr = recvData.data.split('=');          // 截取 = 后部分
            var kday = JSON.parse(jsonStr[1]);   
            HQData.RecvRealtimeData(kday, data, callback, obj);
        }
      })

   
}

HQData.RecvRealtimeData=function(recvData, data, callback, obj)
{
    if (!recvData) return;

    var stockData=recvData.data[obj.InternalSymbol];
    var kLineName=`${obj.FuQuan}${obj.PeriodName}`;
    var jsKline=stockData[kLineName];
	if(jsKline == null || jsKline == undefined){
		var kLineName=`${obj.PeriodName}`;
		var jsKline=stockData[kLineName];
	}
    var stockInfo={ Symbol:obj.Symbol, Period:data.Self.Period, Right:data.Self.Right };

    var stock={name:obj.Symbol, symbol:obj.Symbol };
    var yClose=parseFloat(stockData.prec);
    var latestData;
    for(var i in jsKline)
    {
        var item=jsKline[i];
        var aryDate = item[0].split('-')
        var date=parseInt(aryDate[0])*10000+parseInt(aryDate[1])*100+parseInt(aryDate[2]);
        var open=parseFloat(item[1]);
        var close=parseFloat(item[2]);
        var high=parseFloat(item[3]);
        var low=parseFloat(item[4]);
        var vol=HQData.KLineVolume(obj.Symbol, item[5]);

        stock.yclose=yClose;
        stock.open=open;
        stock.high=high;
        stock.low=low;
        stock.price=close;
        stock.vol=vol;
        stock.amount=null;
        stock.date=date;

        latestData={ Date:item[0], Open:item[1], High:item[3], Low: item[4], Close:item[2], Vol:vol, YClose:yClose };

        yClose=close;
    }

    var hqChartData={code:0, stock:[stock] };
    
    if (data.Self.IsDestroy==false)
    {
        callback(hqChartData);

        if (HQData.RecvDataCallback)
        {
            HQData.RecvDataCallback( { Data:latestData, Stock:stockInfo, Explain:"日K线增量数据",Type: 4 });
        }
    }
}

//腾讯分钟K线url
HQData.GetKMinuteApiUrl2=function(symbol, period, count)
{
    var internalSymbol=HQData.ConverToSinaSymbol(symbol);

    var Period_List=new Map(
        [
            [4,1],
            [5,5],
            [6,15],
            [7,30],
            [8,60]
        ]
    );

    var scale=Period_List.get(period);



    var url=`https://ifzq.gtimg.cn/appstock/app/kline/mkline?param=${internalSymbol},m${scale},,${count}&_var=m${scale}_today`;


    return { Url:url, Symbol:symbol, InternalSymbol:internalSymbol, Period:period };
}
//腾讯分钟K线数据
HQData.RecvHistoryMinuteData2=function(recvData, data, callback, obj)
{
    //{"day":"2021-03-03 14:15:00","open":"22.860","high":"22.900","low":"22.820","close":"22.830","volume":"2337300","ma_price5":22.796,"ma_volume5":1612649},
    var hqChartData={code:0, data:[]};
    hqChartData.symbol=obj.Symbol;
    hqChartData.name=obj.Symbol;

    var stockInfo={ Symbol:obj.Symbol, Period:data.Self.Period, Right:data.Self.Right };
    var yClose=null;
    var latestData=null;	//最新数据
    //var key = recvData.data.split('_today=')[0]
    // var key=`${obj.FuQuan}${obj.PeriodName}`;
   
    // var data = stockData[kLineName]['m1']
    // recvData = JSON.parse(data);
	
    var code=HQData.ConverToSinaSymbol(obj.Symbol);
    recvData= recvData.data[code]['m1'];
   
    for(var i in recvData)
    {
        //if (i==recvData.length-1) break;  //测试自动更新
        var item=recvData[i];
        var time = item[0].substr(0,4)+'-'+item[0].substr(4,2)+'-'+item[0].substr(6,2)+' '+item[0].substr(8,2)+':'+item[0].substr(10,2)+':'+'00';
        var day = new Date(time);

        var date=day.getFullYear()*10000+(day.getMonth()+1)*100+day.getDate();
        var time=day.getHours()*100+day.getMinutes();
        //var vol = Math.round(parseFloat(item[5])/100)*10000;
        var vol = parseFloat(item[5])*100;
        var newItem=[ date,yClose, parseFloat(item[1]), parseFloat(item[3]), parseFloat(item[4]), parseFloat(item[2]), vol, null, time];

        hqChartData.data.push(newItem);

        latestData={ Date:item.day, Open:item[1], High:item[3], Low: item[4], Close:item[2], Vol:vol, YClose:yClose };

        yClose=parseFloat(item[2]);
    }
  
    callback(hqChartData);
    if (HQData.RecvDataCallback)
    {
        HQData.RecvDataCallback( { Data:latestData, Stock:stockInfo, Explain:"分钟K线历史数据",Type: 5});
    }   
}
//股票代码转腾讯代码
HQData.GetInternalSymbolDongFeng=function(symbol)
{
   var aryData=symbol.split(".");
   var market= ((aryData[1]=='sz' || aryData[1]=='bj')? 0:1);
   
   return { Market:market, Symbol:aryData[0] };
}
HQData.GetInternalPeriodDongFeng=function(periodID)
{
    var MAP_PERIOD=new Map(
        [
            [4, 1],    //1min
            [5, 5],    //5min
            [6, 15],   //15min
            [7, 30],   //30min
            [8, 60],    //60min
        ]
    );

    return MAP_PERIOD.get(periodID);
}
HQData.GetInternalRightDongFeng=function(right)
{
    if (right==0) return 0;
    else if (right==1) return 1;
    else return 2;
}
HQData.GetMinuteKLineApiUrlDongFeng=function(symbol, period, right, option)
{
    var internalSymbol=HQData.GetInternalSymbolDongFeng(symbol);
    var internalPeriod=HQData.GetInternalPeriodDongFeng(period);
    var internalRight=HQData.GetInternalRightDongFeng(right);

    if (option && option.Update==true)
    {
        var beginDate=option.End;
        var url=`https://push2his.eastmoney.com/api/qt/stock/kline/get?fields1=f1,f2,f3,f4,f5,f6,f7,f8,f9,f10,f11,f12,f13&fields2=f51,f52,f53,f54,f55,f56,f57,f58,f59,f60,f61&beg=${beginDate}&end=20500101&ut=fa5fd1943c7b386f172d6893dbfba10b&rtntype=6&secid=${internalSymbol.Market}.${internalSymbol.Symbol}&klt=${internalPeriod}&fqt=${internalRight}`;
    }
    else
    {
        var url=`https://push2his.eastmoney.com/api/qt/stock/kline/get?fields1=f1,f2,f3,f4,f5,f6,f7,f8,f9,f10,f11,f12,f13&fields2=f51,f52,f53,f54,f55,f56,f57,f58,f59,f60,f61&beg=0&end=20500101&ut=fa5fd1943c7b386f172d6893dbfba10b&rtntype=6&secid=${internalSymbol.Market}.${internalSymbol.Symbol}&klt=${internalPeriod}&fqt=${internalRight}`;
    }

    return { Url:url, Symbol:symbol, InternalSymbol:internalSymbol, Period:period, Right:right };
}
HQData.RecvHistoryMinuteDataDongFeng=function(recvData, data, callback, obj)
{
    var data=recvData.data.data;
    
    var hqChartData={code:0, data:[]};
    hqChartData.symbol=obj.Symbol;
    hqChartData.name=data.name;
    
    var yClose=data.preKPrice;;
    for(var i=0;i<data.klines.length; ++i)
    {
        var strItem=data.klines[i];
        var item=strItem.split(',');
        var date=item[0].split(' ')[0].replace(/-/g,'');
        var time=item[0].split(' ')[1].replace(/:/g,'');
       
        var open=parseFloat(item[1]);
        var close=parseFloat(item[2]);
        var high=parseFloat(item[3]);
        var low=parseFloat(item[4]);
        var vol=parseFloat(item[5])*100;
        var amount=parseFloat(item[6]);
    
        var newItem=[ date, yClose, open, high, low, close, vol, amount, time];
        hqChartData.data.push(newItem);
    
        yClose=close;
    }
    callback(hqChartData);
    if (HQData.RecvDataCallback)
	{
		HQData.RecvDataCallback( { Data:latestData, Stock:stockInfo, Explain:"分钟K线历史数据",Type: 5});
	}	
}
HQData.RequestHistoryMinuteDataDongFeng=function(data, callback)
{
   data.PreventDefault=true;
   var symbol=data.Request.Data.symbol; //请求的股票代码
   var period=data.Self.Period;    //周期
   var right=data.Self.Right;      //复权
   var obj=HQData.GetMinuteKLineApiUrlDongFeng(symbol,period, right, null);
   axios({
    method:'GET',
    url: obj.Url
    }).then(recvData=>{
        if(recvData){
            //eval(recvData.data);
            HQData.RecvHistoryMinuteDataDongFeng(recvData, data, callback, obj);
        }
    })
}
export default HQData
